import { createFileRoute, Outlet } from '@tanstack/react-router';

/** Layout-only: gives the tab and its detail routes a "Attributes" crumb that links back to the list. */
export const Route = createFileRoute('/_authed/_active/org/catalog-setup/attributes')({
  staticData: { crumb: 'dictionary:setup.tabs.attributes' },
  component: Outlet,
});
